import React from "react";
import * as Styles from "./BasketVehicleCode.styles";
import Icon from "../../../../../../shared-components/toyota/styles/atoms/Icon";
import { getExternalVehicleAttrValue } from "../../../../../../shared-logic/utils/uscUtils";
import { useUscSelector } from "../../../../../redux/store";
import { DfExternalVehicleAttrs } from "../../../../../../shared-logic/utils/dfConstants";
import { useUscLabel } from "../../../../../utils/labels";

const BasketVehicleCode = (): JSX.Element | null => {
    const vehicleCode = useUscSelector((state) =>
        state.vehicle.result
            ? getExternalVehicleAttrValue(state.vehicle.result, DfExternalVehicleAttrs.vehicleCode)
            : null,
    );

    const title = useUscLabel("uscBasketVehicleCodeTitle");

    if (!vehicleCode) return null;

    return (
        <Styles.Wrapper>
            <Styles.Content>
                <Styles.Title>{title}</Styles.Title>
                <Styles.Code>{vehicleCode}</Styles.Code>
            </Styles.Content>
            <Icon variant="car" />
        </Styles.Wrapper>
    );
};

export default BasketVehicleCode;
